import clsx from 'clsx';
import {CheckCircleBoldIcon} from '@solar-icons/react';
import styles from './LinearGraphsWidget.module.css';

const GRID_LINES = Array.from({length: 9}, (_, i) => i * 30);

/** y = x + 1 and y = 2x both draw in and meet at their intersection, (1, 2). */
export default function LinearGraphsWidget({playing}) {
    return (
        <>
            <div className={styles.chips}>
                <span className={styles.chipTeal}><span className={styles.chipDotTeal}/><em>y</em> = <em>x</em> + 1</span>
                <span className={styles.chipOrange}><span className={styles.chipDotOrange}/><em>y</em> = 2<em>x</em></span>
            </div>
            <svg viewBox="0 0 240 240" className={styles.svg}>
                {GRID_LINES.map((p) => (
                    <line key={`v${p}`} x1={p} y1="0" x2={p} y2="240" stroke="var(--color-primary-100)" strokeWidth="1"/>
                ))}
                {GRID_LINES.map((p) => (
                    <line key={`h${p}`} x1="0" y1={p} x2="240" y2={p} stroke="var(--color-primary-100)" strokeWidth="1"/>
                ))}
                <line x1="120" y1="0" x2="120" y2="240" stroke="var(--color-primary-400)" strokeWidth="1.5"/>
                <line x1="0" y1="120" x2="240" y2="120" stroke="var(--color-primary-400)" strokeWidth="1.5"/>
                <text x="228" y="134" fill="var(--color-neutral-600)" className={styles.axisLabel}>x</text>
                <text x="126" y="12" fill="var(--color-neutral-600)" className={styles.axisLabel}>y</text>
                <line
                    x1="0" y1="210" x2="210" y2="0"
                    stroke="var(--color-primary-600)" strokeWidth="3.5" strokeLinecap="round" strokeDasharray="420"
                    className={clsx(styles.lineTeal, playing && styles.animated)}
                />
                <line
                    x1="60" y1="240" x2="180" y2="0"
                    stroke="var(--home-color-orange)" strokeWidth="3.5" strokeLinecap="round" strokeDasharray="420"
                    className={clsx(styles.lineOrange, playing && styles.animated)}
                />
                <circle
                    cx="150" cy="60" r="7" fill="var(--color-neutral-50)" stroke="var(--color-neutral-900)" strokeWidth="2.5"
                    className={clsx(styles.intersection, playing && styles.animated)}
                />
            </svg>
            <div className={styles.footer}>
                <span>Lines cross where <em>x</em> =</span>
                <div className={styles.answerBox}>
                    <span className={clsx(styles.answerDigit, playing && styles.rise)}>1</span>
                </div>
                <CheckCircleBoldIcon
                    size={22}
                    color="var(--color-feedback-correct-vivid)"
                    className={clsx(styles.tick, playing && styles.pop)}
                />
            </div>
        </>
    );
}
